@use "styles" as *;

.me-load-container {
  display: block;
  position: relative;

  &__spinner {
    & > [slot=spinner],
    & > [name=spinner] {
      display: block;
      position: absolute;
      pointer-events: none;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      background: $me-load-container-spinner-background;
      backdrop-filter: blur($me-load-container-spinner-backdrop-blur);
      background-blend-mode: overlay;
      border-radius: $border-radius;
      color: $me-load-container-spinner-color;

      &[hidden] {
        display: none;
      }

      > * {
        display: block;
        aspect-ratio: 1;
        margin: calc(($me-load-container-spinner-size - 1rem) / 2);
      }
    }
  }

  &:not(&--is-loading) &__spinner {
    display: none;
  }
}
